import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { automaticService } from "services";
import { logout } from "../logout";

export const getAssemblies = createAsyncThunk(
  "getAssemblies",
  async (
    {
      assemblyStatus,
      oadUpdateStatus,
      startDate,
      endDate,
      skip,
      limit,
      searchExpression,
      //pcbType is deprecated filter, it will be deleted when new dashboard is released
      pcbType,
      pcbaTypes,
      workOrders,
    },
    { rejectWithValue }
  ) => {
    try {
      return await automaticService.get_assemblies(
        assemblyStatus,
        oadUpdateStatus,
        startDate,
        endDate,
        skip,
        limit,
        searchExpression,
        pcbType,
        pcbaTypes,
        workOrders
      );
    } catch (error) {
      if (error.message) {
        if (error?.response?.status === 401) {
          logout();
        }
        //No response to request (No service)
        console.log("Internet Disconnected");
      } else {
        console.log(error);
        return rejectWithValue(error);
      }
    }
  }
);

const initialState = {
  result: null,
  loading: false,
  error: null,
};

const assembliesSlice = createSlice({
  name: "assemblies",
  initialState: initialState,
  reducers: {
    clearAssembliesList: (state, _action) => {
      state.result = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAssemblies.pending, (state, _action) => {
      state.loading = true;
    });
    builder.addCase(getAssemblies.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
      state.error = null;
    });
    builder.addCase(getAssemblies.rejected, (state, action) => {
      state.loading = false;
      state.result = null;
      state.error = action.payload;
    });
  },
});

export const { clearAssembliesList } = assembliesSlice.actions;
export default assembliesSlice.reducer;
